import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { Fragment, useState, useRef, useEffect, useCallback, useLayoutEffect } from 'react';
import { connect } from 'react-redux';
import Slider from 'rc-slider';
import _, { forEach as _forEach, cloneDeep as _cloneDeep } from 'lodash';
import { ProgressBar, Card, Collapse, Button } from 'react-bootstrap';
import withRouter from 'js/withRouter';
import { legacyInjectIntl } from 'js/wrapper/injectIntl';
import CustomScrollbar from 'js/wrapper/CustomScrollbar';
import { updateVar } from 'actions/LayoutActions';
import { getPageNameIndex } from './actions/TemplateSettings';
import TemplateBlockCategoryFTs from './TemplateBlockCategoryFTs';
import EditorPageNavigatorFTs from './EditorPageNavigatorFTs';
import EditorPageFTs from './EditorPageFTs';
import { getDeviceType } from './actions/deviceType';
import CollapsibleSidebar from './CollapsibleSidebar';
import { AICopilot } from 'cc-editor/components/AICopilot';
const EditorCanvasFTs = (props) => {
    var _a, _b, _c, _d, _e, _f, _g;
    // destructure heavy props used directly
    const { contentPages, setActiveHeight, activateZoom, zHeight, zWidth, updateCurrentPage, updateParam, templateSettings, templateBlocks, pagePreview, pageFinder, insertContentBlock, appIntl, updateInnerBlock, blockContainer, filesUploading, usedMedia, raster, currentPage, errorsCount, errorsText, changeBlock, removeContentBlock, resetBlock, copyBlock, copiedBlock, pasteBlock, pasteData, resizeBlock, updateSpecialBlockAttributes, imageUpload, pageHeights, pageWidths, publisherInfo, rootUser, wlAdminUser, isSubmission, onlyWhitelabelAdminCanModifyBlocks, savingR, goToLastPageState, goToLastPage, resetPage, resetPageState, saveDescription, updateBlocksState, uploadError, fontSizeSettings, colorSettings, resetStates, updateVar, topPaddings, rightPaddings, bottomPaddings, leftPaddings, editionSettings, showSettingsF, } = props;
    // Local state (converted from this.state)
    const [pageZoom, setPageZoom] = useState(1);
    const [pageOffset, setPageOffset] = useState(0);
    const [stageOffset, setStageOffset] = useState(0);
    const [pageWidth, setPageWidth] = useState(null);
    const [pageHeight, setPageHeight] = useState(null);
    const [stageWidth, setStageWidth] = useState(null);
    const [stageHeight, setStageHeight] = useState(null);
    const [printPages, setPrintPages] = useState(false);
    const [printPages3D, setPrintPages3D] = useState(false);
    const [gridActive, setGridActive] = useState(false);
    const [trimBorderActive, setTrimBorderActive] = useState(' active');
    const [hideBars, setHideBars] = useState({
        stageWrapHeight: '',
        stageWrapTop: '',
        stageHeight: '',
    });
    const [showKeyboard, setShowKeyboard] = useState(true);
    const [allUsedBlocks, setAllUsedBlocksState] = useState([]);
    const [allUsedBlocksContent, setAllUsedBlocksContentState] = useState([]);
    const [contentPagesPrev, setContentPagesPrev] = useState(undefined);
    const [openPageFinder, setOpenPageFinder] = useState(true);
    const [editorPageNavigator, setEditorPageNavigator] = useState({
        show: true,
        classNameNav: 'showEditorPageNavigator ',
        classNameButton: 'editorPageNavigatorOpenedButton',
    });
    const [init, setInit] = useState(false);
    const [selectedObjectForAI, setSelectedObjectForAI] = useState(null);
    const messages = (_b = (_a = appIntl === null || appIntl === void 0 ? void 0 : appIntl.messages) === null || _a === void 0 ? void 0 : _a.messages) !== null && _b !== void 0 ? _b : {};
    const zoomerRef = useRef(null);
    const stageRef = useRef(null);
    // Helper: setActiveHeight effect dependency
    const prevPropsRef = useRef({ updateNotification: props.updateNotification, activateZoom: props.activateZoom, savingR: props.savingR });
    // updatePageSize equivalent
    const updatePageSize = useCallback((pw, ph) => {
        setPageWidth(pw);
        setPageHeight(ph);
    }, []);
    // updateStageSize equivalent
    const updateStageSize = useCallback(() => {
        if (stageRef.current &&
            stageRef.current.offsetWidth !== null &&
            stageRef.current.offsetHeight !== null) { // Todo new
            const w = stageRef.current.offsetWidth;
            const h = stageRef.current.offsetHeight;
            if (w !== null && h !== null) {
                setStageWidth(w);
                setStageHeight(h);
            }
        }
    }, []);
    // fitWidth
    const fitWidth = useCallback(() => {
        const pw = pageWidth !== null && pageWidth !== void 0 ? pageWidth : 0;
        const sw = stageWidth !== null && stageWidth !== void 0 ? stageWidth : 0;
        if (pw === 0)
            return;
        const neededZoom = (sw - 250) / (pw + 40);
        setPageZoom(parseFloat(neededZoom.toFixed(2)));
    }, [pageWidth, stageWidth]);
    // fitHeight
    const fitHeight = useCallback(() => {
        const ph = pageHeight !== null && pageHeight !== void 0 ? pageHeight : 0;
        const sh = stageHeight !== null && stageHeight !== void 0 ? stageHeight : 0;
        if (ph === 0)
            return;
        const neededZoom = (sh - 80) / ph;
        setPageZoom(parseFloat(neededZoom.toFixed(2)));
    }, [pageHeight, stageHeight]);
    // fitAuto
    const fitAuto = useCallback(() => {
        const pw = pageWidth !== null && pageWidth !== void 0 ? pageWidth : 0;
        const sw = stageWidth !== null && stageWidth !== void 0 ? stageWidth : 0;
        const ph = pageHeight !== null && pageHeight !== void 0 ? pageHeight : 0;
        const sh = stageHeight !== null && stageHeight !== void 0 ? stageHeight : 0;
        if (!pw || !ph || !sw || !sh)
            return;
        let neededZoomWidth;
        if (getDeviceType() === 'mobile') {
            neededZoomWidth = (sw - 40) / pw;
            if (props.viewActive) {
                updateVar('viewActiveFalse');
            }
        }
        else {
            neededZoomWidth = (sw - 250) / (pw + 40);
        }
        const neededZoomHeight = (sh - 80) / ph;
        const neededZoom = neededZoomHeight < neededZoomWidth ? neededZoomHeight : neededZoomWidth;
        const _hideBars = _cloneDeep(hideBars);
        if (props.updateNotification && props.updateNotification.length > 0) {
            if (window.innerWidth <= 1024) {
                _hideBars.stageWrapHeight = 'calc(100% - 228px)';
            }
            else {
                _hideBars.stageWrapHeight = 'calc(100% - 200px)';
            }
        }
        else {
            if (window.innerWidth <= 1024) {
                _hideBars.stageWrapHeight = 'calc(100% - 178px)';
            }
            else {
                _hideBars.stageWrapHeight = 'calc(100% - 150px)';
            }
        }
        _hideBars.stageWrapTop = '';
        _hideBars.stageHeight = '';
        updateVar('ccToolbarBlock');
        setHideBars(_hideBars);
        setPageZoom(parseFloat(neededZoom.toFixed(2)));
    }, [pageWidth, stageWidth, pageHeight, stageHeight, hideBars, props.updateNotification, updateVar, props.viewActive]);
    useEffect(() => {
        if (props.ccToolbar === 'none') {
            if (props.scrollView && typeof props.scrollView.scrollIntoView === 'function') {
                try {
                    props.scrollView.scrollIntoView({ block: 'start' });
                }
                catch (err) {
                    // ignore
                }
            }
        }
    }, [pageZoom, props.scrollView, props.ccToolbar]);
    // fitByMobileZoom
    const fitByMobileZoom = useCallback((zElementHeight, zElementWidth) => {
        const _hideBars = _cloneDeep(hideBars);
        const neededZoom = props.zoomFactor * 1 || 1;
        _hideBars.stageWrapHeight = 'calc(100% - 50px)';
        _hideBars.stageWrapTop = '0px';
        _hideBars.stageHeight = 'calc(100% - 0px)';
        updateVar('ccToolbarNone');
        setHideBars(_hideBars);
        setPageZoom(parseFloat(neededZoom.toFixed(2))); // callback i.o. - done via useEffect
        // scroll into view after zoom
    }, [hideBars, props.zoomFactor, updateVar, props.scrollView]);
    // toggleTrimBorder
    const toggleTrimBorder = useCallback(() => {
        setTrimBorderActive((prev) => (prev === '' ? ' active' : ''));
    }, []);
    // showPages / showPages3D / showGrid
    const showPagesF = useCallback((what) => setPrintPages(!what), []);
    const showPages3DF = useCallback((what) => setPrintPages3D(!what), []);
    const showGridF = useCallback((what) => setGridActive(!what), []);
    // setCurrentPage (unused in render but preserved)
    const setCurrentPage = useCallback((e) => {
        var _a;
        const t = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.innerText;
        if (t)
            updateCurrentPage(parseInt(t, 10) - 1);
    }, [updateCurrentPage]);
    // toggleKeyboard
    const toggleKeyboard = useCallback(() => {
        setShowKeyboard((prev) => !prev);
    }, []);
    // setAllUsedBlocks (converted)
    const setAllUsedBlocks = useCallback((pages) => {
        const allUsed = [];
        const allUsedContent = [];
        _forEach(pages, (pagesItem) => {
            _forEach(pagesItem === null || pagesItem === void 0 ? void 0 : pagesItem.blocks, (block) => {
                const usedBlock = { id: block === null || block === void 0 ? void 0 : block.template_id };
                allUsed.push(usedBlock);
                allUsedContent.push(block);
                if ((block === null || block === void 0 ? void 0 : block.blocks) && block.blocks.length > 0) {
                    _forEach(block.blocks, (containerBlock) => {
                        const usedBlockInsideContainer = { id: containerBlock === null || containerBlock === void 0 ? void 0 : containerBlock.template_id };
                        allUsed.push(usedBlockInsideContainer);
                        allUsedContent.push(containerBlock);
                    });
                }
            });
        });
        setAllUsedBlocksState(allUsed);
        setAllUsedBlocksContentState(allUsedContent);
    }, []);
    // showEditorPageNavigatorF
    const showEditorPageNavigatorF = useCallback(() => {
        setEditorPageNavigator((prev) => (prev === null || prev === void 0 ? void 0 : prev.show) === true
            ? { show: false, classNameNav: 'hideEditorPageNavigator ', classNameButton: 'editorPageNavigatorClosedButton' }
            : { show: true, classNameNav: 'showEditorPageNavigator ', classNameButton: 'editorPageNavigatorOpenedButton' });
    }, []);
    // lifecycle: componentDidMount replacement
    useLayoutEffect(() => {
        // initial stage dimensions
        const stageEl = stageRef.current;
        if (stageEl) {
            setStageWidth(stageEl.offsetWidth);
            setStageHeight(stageEl.offsetHeight);
        }
        // initial used blocks
        setAllUsedBlocks(contentPages);
        // window resize listener (throttled)
        const throttled = _.throttle(updateStageSize, 200);
        window.addEventListener("resize", throttled);
        // cleanup on unmount
        return () => {
            window.removeEventListener("resize", throttled);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        if (init)
            return;
        if (!stageWidth || !stageHeight)
            return;
        if (!pageWidths || !pageHeights || pageWidths.length === 0)
            return;
        fitAuto();
        setInit(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [stageWidth, stageHeight, pageWidths, pageHeights, activateZoom]);
    useEffect(() => {
        fitAuto();
    }, [window.innerWidth]);
    // componentDidUpdate replacement for various prop/state changes
    useEffect(() => {
        // 1) updateNotification change -> fitAuto
        if (prevPropsRef.current.updateNotification !== props.updateNotification) {
            fitAuto();
        }
        // 3) pageHeight change -> setActiveHeight
        if (pageHeight !== undefined && pageHeight !== null && prevPropsRef.current.pageHeight !== pageHeight) {
            setActiveHeight(pageHeight);
        }
        // 4) activateZoom handling
        if (prevPropsRef.current.activateZoom !== activateZoom && activateZoom === true) {
            fitByMobileZoom(zHeight !== null && zHeight !== void 0 ? zHeight : 0, zWidth !== null && zWidth !== void 0 ? zWidth : 0);
            updateVar('activateZoomFalse');
        }
        // update prevPropsRef snapshot
        prevPropsRef.current = {
            updateNotification: props.updateNotification,
            activateZoom,
            savingR,
            pageHeight,
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.updateNotification, pageHeight, activateZoom, zHeight, zWidth, savingR]);
    useEffect(() => {
        if (contentPages) {
            setAllUsedBlocks(contentPages);
        }
    }, [contentPages, setAllUsedBlocks]);
    const currentPageNum = parseInt(String(currentPage), 10);
    const spaceConsumed = (_c = contentPages[parseInt(String(currentPage), 10)]) === null || _c === void 0 ? void 0 : _c.space_consumed;
    const formatPages = templateSettings.format;
    let systemProgress = _jsx(ProgressBar, { variant: "success", now: 0 });
    let bs = 'danger';
    if (savingR) {
        systemProgress = (_jsx(ProgressBar, { id: "progSAVE", striped: true, animated: true, variant: "danger", now: 100, label: messages.editor.content_is_saved }));
    }
    else if (filesUploading.length > 0) {
        const totalFiles = filesUploading.length;
        const maxProgress = 100 / totalFiles;
        const progressInstance = [];
        for (let i = 0; i < totalFiles; i++) {
            const now = maxProgress; // filesUploading[i]['completed'] * (maxProgress / 100);
            const currentProgress = (_jsx(ProgressBar, { id: `prog${i}`, striped: true, variant: bs, now: now, label: `Upload ${i + 1} von ${totalFiles}` }, `totalFiles_${i}`));
            progressInstance.push(currentProgress);
            if (bs === 'danger') {
                bs = 'warning';
            }
            else if (bs === 'warning') {
                bs = 'info';
            }
            else if (bs === 'info') {
                bs = 'success';
            }
            else {
                bs = 'danger';
            }
        }
        systemProgress = (_jsx(ProgressBar, { children: progressInstance.map((pgi, i) => {
                return pgi;
            }) }));
    }
    const pageNameIndex = getPageNameIndex(currentPage, templateSettings, contentPages.length);
    const contentBlocks = contentPages[currentPageNum].blocks;
    const previousPages = [];
    const nextPages = [];
    let printPagesOption = false;
    let printPageActive = '';
    let printPage3DActive = '';
    let grid = '';
    if (printPages) {
        printPageActive = 'active';
    }
    if (printPages3D) {
        printPage3DActive = 'active';
    }
    if (gridActive) {
        grid = ' grid';
    }
    if (formatPages.divide_pages === 'double') {
        printPagesOption = true;
        if (printPages) {
            if (currentPage === 0) {
                if (formatPages.order_pages !== 'first-last-single' &&
                    formatPages.order_pages !== 'down-up' &&
                    formatPages.order_pages !== 'firstDown-up') {
                    nextPages.push(currentPage + 1);
                }
                else if (formatPages.order_pages === 'firstDown-up') {
                    previousPages.push(currentPage + 1);
                }
            }
            else if (currentPage === contentPages.length - 1) {
                if (formatPages.order_pages !== 'first-last-single' && formatPages.order_pages !== 'up-down') {
                    previousPages.push(currentPage - 1);
                }
            }
            else if (currentPage % 2 === 0) {
                if (formatPages.order_pages === 'first-last-single') {
                    previousPages.push(currentPage - 1);
                }
                else {
                    nextPages.push(currentPage + 1);
                }
            }
            else if (formatPages.order_pages === 'first-last-single' && formatPages.order_pages !== 'firstDown-up') {
                nextPages.push(currentPage + 1);
            }
            else if (currentPage === 1 && formatPages.order_pages === 'firstDown-up') {
                nextPages.push(currentPage - 1);
            }
            else {
                previousPages.push(currentPage - 1);
            }
        }
    }
    else if (formatPages.divide_pages === 'half') {
        printPagesOption = true;
        if (printPages) {
            const halfPages = contentPages.length / 2;
            const endHalf = halfPages > currentPage ? halfPages : contentPages.length;
            for (let i = halfPages <= currentPage ? halfPages : 0; i < endHalf; i++) {
                if (i < currentPage) {
                    if (formatPages.order_pages === 'down-up') {
                        if (i < halfPages) {
                            nextPages.unshift(i);
                        }
                        else {
                            previousPages.push(i);
                        }
                    }
                    else {
                        previousPages.push(i);
                    }
                }
                else if (i > currentPage) {
                    if (formatPages.order_pages === 'down-up') {
                        if (i < halfPages) {
                            previousPages.unshift(i);
                        }
                        else {
                            nextPages.push(i);
                        }
                    }
                    else {
                        nextPages.push(i);
                    }
                }
            }
        }
    }
    else if (formatPages.divide_pages === 'double-single') {
        printPagesOption = true;
        if (printPages) {
            if (currentPage === 0) {
                previousPages.push(currentPage + 1);
            }
            else if (currentPage === 1) {
                nextPages.push(currentPage - 1);
            }
            else if (currentPage === 2) {
                nextPages.push(currentPage + 1);
            }
            else if (currentPage === 3) {
                previousPages.push(currentPage - 1);
            }
        }
    }
    let previousWidth = 0;
    let previousHeight = 0;
    let nextWidth = 0;
    let nextHeight = 0;
    const widthFix = (previousPages.length + nextPages.length + 1) *
        ((pageWidths[currentPage] ? pageWidths[currentPage] : pageWidths[0]) * pageZoom) +
        200 +
        'px';
    const pageIndex = currentPage;
    let newPageZoom;
    let wtErrors;
    if (errorsCount === 0) {
        wtErrors = (_jsx("a", { href: "#", "data-tooltip-content": "Weiter so...!", "data-tooltip-id": "editor-canvas-tooltip", className: "no-problems", children: messages.editor.no_error }));
    }
    else {
        wtErrors = (_jsxs("a", { href: "#", "data-tooltip-content": errorsText, "data-tooltip-id": "editor-canvas-tooltip", "data-html": "true", "data-type": "error", className: "problems", children: [errorsCount, " ", messages.editor.error] }));
    }
    const currentEvenOdd = (currentPageNum + 1) % 2 === 0 ? ' even' : ' odd';
    let showIt = 'none';
    if (props.viewActive) {
        showIt = 'block';
    }
    let stageColorClasses = '';
    let filteredStageColorSettings = [];
    filteredStageColorSettings = _.filter(colorSettings, setting => setting.id === 'stage');
    _forEach(filteredStageColorSettings, (filteredStageColorSetting, i) => {
        stageColorClasses = stageColorClasses + ' ' + filteredStageColorSetting.color;
    });
    let deviceType = getDeviceType();
    let hiddenAtMobileZoom = props.ccToolbar === 'none' ? { display: "none" } : {};
    const mainSidebarTabs = [
        {
            key: 'blocks-main-tab',
            icon: 'fad fa-th-large',
            tooltip: 'Template Blocks',
            hidden: false,
            content: (_jsx(TemplateBlockCategoryFTs, { allUsedBlocks: allUsedBlocks, allUsedBlocksContent: allUsedBlocksContent, blockContainer: blockContainer, currentPage: currentPage, endless: !!templateSettings.pages[pageNameIndex].endless, init: props.init, insertContentBlock: insertContentBlock, pageAmount: contentPages.length, pageSpace: templateSettings.pages[pageNameIndex].page_space, raster: raster, templateBlocks: templateBlocks, templateSettings: templateSettings, updatePageSize: updatePageSize, usedBlocks: contentBlocks })),
        },
        {
            key: 'custom-feature-tab',
            icon: 'fa-duotone fa-solid fa-robot',
            tooltip: 'AI Copilot',
            hidden: false,
            content: (_jsx(AICopilot, { selectedObject: selectedObjectForAI, setSelectedObject: setSelectedObjectForAI, editionSettings: editionSettings, showSettingsF: showSettingsF })),
        },
    ];
    // Render
    return (_jsxs("div", { id: "scarlet_editor", children: [_jsxs("div", { id: "stage-wrap", style: { height: hideBars.stageWrapHeight, top: hideBars.stageWrapTop }, children: [_jsx("div", { ref: stageRef, id: "stage", className: 'anzahl_' + contentPages.length + stageColorClasses, "data-page": currentPage, "data-zoom": pageZoom, style: { height: hideBars.stageHeight }, children: _jsx(CustomScrollbar, { style: { overflowX: 'auto', overflowY: 'auto' }, children: _jsxs("div", { className: "widthFix", style: { width: widthFix }, children: [(printPages || printPages3D) && previousPages.length !== 0
                                        ? previousPages.map((pPage, i) => {
                                            var _a, _b, _c, _d;
                                            const pPageNum = parseInt(String(pPage), 10);
                                            const evenOdd = (pPageNum + 1) % 2 === 0 ? ' even' : ' odd';
                                            previousWidth += parseFloat(pageWidths[pPageNum] ? pageWidths[pPageNum] : pageWidths[0]);
                                            previousHeight += parseFloat(pageHeights[pPageNum] ? pageHeights[pPageNum] : pageHeights[0]);
                                            const pageNameIndexP = getPageNameIndex(pPageNum, templateSettings, contentPages.length);
                                            return (_jsx(EditorPageFTs, { allUsedBlocks: allUsedBlocks, allUsedBlocksContent: allUsedBlocksContent, blockContainer: blockContainer, blocks: contentPages[pPageNum].blocks, colorSettings: colorSettings, currentPage: pPage, deleteSelectedColor: props.deleteSelectedColor, evenOdd: evenOdd, filesUploading: filesUploading, fitAuto: fitAuto, fontSizeSettings: fontSizeSettings, getColorSettings: props.getColorSettings, getDeviceType: getDeviceType, goToLastPage: goToLastPage, goToLastPageState: goToLastPageState, grid: grid, index: pageIndex, initDefaultPosition: props.initDefaultPosition, isSubmission: isSubmission, marginWidth: previousWidth, navEntry: props.navEntry, onlyWhitelabelAdminCanModifyBlocks: onlyWhitelabelAdminCanModifyBlocks, paddingBottom: Number((_a = templateSettings.pages[pageNameIndexP].padding_bottom) !== null && _a !== void 0 ? _a : (bottomPaddings ? parseFloat((_b = bottomPaddings[pPageNum]) !== null && _b !== void 0 ? _b : bottomPaddings[0]) : 0)), paddingTop: Number((_c = templateSettings.pages[pageNameIndexP].padding_top) !== null && _c !== void 0 ? _c : (topPaddings ? parseFloat((_d = topPaddings[pPageNum]) !== null && _d !== void 0 ? _d : topPaddings[0]) : 0)), pageHeight: Number(pageHeights[pPageNum] ? pageHeights[pPageNum] : pageHeights[0]), pagesCount: contentPages.length, pageWidth: Number(pageWidths[pPageNum] ? pageWidths[pPageNum] : pageWidths[0]), pageZoom: pageZoom, publisherInfo: publisherInfo, raster: raster, resetBlock: resetBlock, resetNavEntry: props.resetNavEntry, resetPage: resetPage, resetPageState: resetPageState, resetStates: resetStates, resizeBlock: resizeBlock, rootUser: rootUser, setActiveHeight: setActiveHeight, setFontSizeSettings: props.setFontSizeSettings, setSelectedColor: props.setSelectedColor, setSelectedObjectForAI: setSelectedObjectForAI, selectedObjectForAI: selectedObjectForAI, settings: templateSettings, stageWidth: stageWidth, templateBlocks: templateBlocks, trimBorderActive: trimBorderActive, type: "previous", updateBlock: props.updateBlock, updateBlocksState: updateBlocksState, updateCurrentPage: updateCurrentPage, updatePageSize: updatePageSize, updateParam: updateParam, updateSpecialBlockAttributes: updateSpecialBlockAttributes, website: props.website, wlAdminUser: wlAdminUser }, pPage));
                                        })
                                        : null, _jsx(EditorPageFTs, { allUsedBlocks: allUsedBlocks, allUsedBlocksContent: allUsedBlocksContent, blockContainer: blockContainer, blocks: contentBlocks, changeBlock: changeBlock, colorSettings: colorSettings, copiedBlock: copiedBlock, copyBlock: copyBlock, currentPage: currentPage, deleteSelectedColor: props.deleteSelectedColor, evenOdd: currentEvenOdd, filesUploading: filesUploading, fitAuto: fitAuto, fontSizeSettings: fontSizeSettings, getColorSettings: props.getColorSettings, getDeviceType: getDeviceType, goToLastPage: goToLastPage, goToLastPageState: goToLastPageState, grid: grid, imageUpload: imageUpload, index: pageIndex, initDefaultPosition: props.initDefaultPosition, isSubmission: isSubmission, marginWidth: previousWidth + parseFloat(pageWidths[currentPageNum] ? pageWidths[currentPageNum] : pageWidths[0]), navEntry: props.navEntry, onlyWhitelabelAdminCanModifyBlocks: onlyWhitelabelAdminCanModifyBlocks, paddingBottom: (_d = templateSettings.pages[pageNameIndex].padding_bottom) !== null && _d !== void 0 ? _d : (bottomPaddings ? parseFloat((_e = bottomPaddings[currentPageNum]) !== null && _e !== void 0 ? _e : bottomPaddings[0]) : null), paddingTop: Number((_f = templateSettings.pages[pageNameIndex].padding_top) !== null && _f !== void 0 ? _f : (topPaddings ? parseFloat((_g = topPaddings[currentPageNum]) !== null && _g !== void 0 ? _g : topPaddings[0]) : null)), pageHeight: Number(pageHeights[currentPageNum] ? pageHeights[currentPageNum] : pageHeights[0]), pagesCount: contentPages.length, pageWidth: Number(pageWidths[currentPageNum] ? pageWidths[currentPageNum] : pageWidths[0]), pageZoom: pageZoom, pasteBlock: pasteBlock, pasteData: pasteData, publisherInfo: publisherInfo, raster: raster, removeContentBlock: removeContentBlock, resetBlock: resetBlock, resetNavEntry: props.resetNavEntry, resetPage: resetPage, resetPageState: resetPageState, resetStates: resetStates, resizeBlock: resizeBlock, rootUser: rootUser, saveDescription: saveDescription, setActiveHeight: setActiveHeight, setBlockContainer: props.setBlockContainer, setFontSizeSettings: props.setFontSizeSettings, setSelectedColor: props.setSelectedColor, setSelectedObjectForAI: setSelectedObjectForAI, selectedObjectForAI: selectedObjectForAI, settings: templateSettings, showKeyboard: showKeyboard, stageWidth: stageWidth, templateBlocks: templateBlocks, trimBorderActive: trimBorderActive, type: "active", updateBlock: props.updateBlock, unsetBlockContainer: props.unsetBlockContainer, updateBlocksState: updateBlocksState, updateCurrentPage: updateCurrentPage, updateInnerBlock: updateInnerBlock, updatePageSize: updatePageSize, updateParam: updateParam, updateSpecialBlockAttributes: updateSpecialBlockAttributes, uploadError: uploadError, usedMedia: usedMedia, website: props.website, wlAdminUser: wlAdminUser }), (printPages || printPages3D) && nextPages.length !== 0
                                        ? nextPages.map((nPage, i) => {
                                            var _a, _b, _c, _d;
                                            const nPageNum = parseInt(String(nPage), 10);
                                            nextWidth += parseFloat(pageWidths[nPageNum] ? pageWidths[nPageNum] : pageWidths[0]);
                                            nextHeight += parseFloat(pageHeights[nPageNum] ? pageHeights[nPageNum] : pageHeights[0]);
                                            const pageNameIndexN = getPageNameIndex(nPageNum, templateSettings, contentPages.length);
                                            const evenOdd = (nPageNum + 1) % 2 === 0 ? ' even' : ' odd';
                                            return (_jsx(EditorPageFTs, { allUsedBlocks: allUsedBlocks, allUsedBlocksContent: allUsedBlocksContent, blockContainer: blockContainer, blocks: contentPages[nPageNum].blocks, colorSettings: colorSettings, currentPage: nPage, deleteSelectedColor: props.deleteSelectedColor, evenOdd: evenOdd, filesUploading: filesUploading, fitAuto: fitAuto, fontSizeSettings: fontSizeSettings, getColorSettings: props.getColorSettings, getDeviceType: getDeviceType, goToLastPage: goToLastPage, goToLastPageState: goToLastPageState, grid: grid, index: pageIndex, initDefaultPosition: props.initDefaultPosition, isSubmission: isSubmission, marginWidth: previousWidth +
                                                    nextWidth +
                                                    parseFloat(pageWidths[currentPageNum] ? pageWidths[currentPageNum] : pageWidths[0]), navEntry: props.navEntry, onlyWhitelabelAdminCanModifyBlocks: onlyWhitelabelAdminCanModifyBlocks, paddingBottom: Number((_a = templateSettings.pages[pageNameIndexN].padding_bottom) !== null && _a !== void 0 ? _a : (bottomPaddings ? parseFloat((_b = bottomPaddings[nPageNum]) !== null && _b !== void 0 ? _b : bottomPaddings[0]) : 0)), paddingTop: Number((_c = templateSettings.pages[pageNameIndexN].padding_top) !== null && _c !== void 0 ? _c : (topPaddings ? parseFloat((_d = topPaddings[nPageNum]) !== null && _d !== void 0 ? _d : topPaddings[0]) : 0)), pageHeight: Number(pageHeights[nPageNum] ? pageHeights[nPageNum] : pageHeights[0]), pagesCount: contentPages.length, pageWidth: Number(pageWidths[nPageNum] ? pageWidths[nPageNum] : pageWidths[0]), pageZoom: pageZoom, publisherInfo: publisherInfo, raster: raster, resetBlock: resetBlock, resetNavEntry: props.resetNavEntry, resetPage: resetPage, resetPageState: resetPageState, resetStates: resetStates, resizeBlock: resizeBlock, rootUser: rootUser, setActiveHeight: setActiveHeight, setFontSizeSettings: props.setFontSizeSettings, setSelectedColor: props.setSelectedColor, setSelectedObjectForAI: setSelectedObjectForAI, selectedObjectForAI: selectedObjectForAI, settings: templateSettings, stageWidth: stageWidth, templateBlocks: templateBlocks, trimBorderActive: trimBorderActive, type: "next", updateBlock: props.updateBlock, updateBlocksState: updateBlocksState, updateCurrentPage: updateCurrentPage, updatePageSize: updatePageSize, updateParam: updateParam, updateSpecialBlockAttributes: updateSpecialBlockAttributes, website: props.website, wlAdminUser: wlAdminUser }, nPage));
                                        })
                                        : null] }, "scrollbar") }) }, "stage"), _jsx(CollapsibleSidebar, { tabs: mainSidebarTabs }), _jsxs("div", { id: "pagesCanvas", className: (editorPageNavigator === null || editorPageNavigator === void 0 ? void 0 : editorPageNavigator.classNameNav) + 'stagePreview' + stageColorClasses, style: hiddenAtMobileZoom, children: [_jsxs(Card, { id: "pagesPreview", children: [_jsx(Card.Title, { onClick: () => setOpenPageFinder((p) => !p), children: _jsx("a", { href: "#", children: messages.editor.page_arrangement }) }), _jsx(Collapse, { in: openPageFinder, children: _jsx(Card.Body, { children: pageFinder }) })] }), _jsx(EditorPageNavigatorFTs, { pageIndex: pageIndex, pageNameIndex: pageNameIndex, pages: pagePreview, updateCurrentPage: updateCurrentPage })] }), _jsx(Button, { className: editorPageNavigator === null || editorPageNavigator === void 0 ? void 0 : editorPageNavigator.classNameButton, style: hiddenAtMobileZoom, onClick: () => showEditorPageNavigatorF(), children: (editorPageNavigator === null || editorPageNavigator === void 0 ? void 0 : editorPageNavigator.show) ? _jsx("i", { className: "far fa-angle-double-left" }) : _jsx("i", { className: "far fa-angle-double-right" }) })] }, "stage-wrap"), _jsx("div", { id: "context-modal" }), getDeviceType() === 'mobile' && (_jsxs(_Fragment, { children: [_jsx("div", { className: "disableZoom", style: { display: showIt }, onClick: () => fitAuto(), children: _jsx("i", { className: "fas fa-search-minus" }) }), _jsx("div", { className: "disableKeyboard", style: { display: showIt }, onClick: () => toggleKeyboard(), children: _jsx("i", { className: "fas fa-keyboard" }) })] })), _jsxs("div", { id: "toolbarBottom", children: [_jsx("div", { id: "errorBox", children: wtErrors }), _jsx("div", { id: "system-progress", children: systemProgress }), _jsxs("div", { id: "leftSide", children: [printPagesOption ? (_jsx(Fragment, { children: _jsx("a", { href: "#", onClick: () => {
                                        showPagesF(printPages);
                                    }, className: printPageActive, "data-tooltip-content": messages.editor.print_sheet_view, "data-tooltip-id": "editor-canvas-tooltip", children: _jsx("i", { className: "far fa-columns" }) }) })) : null, _jsx("a", { href: "#", onClick: () => {
                                    toggleTrimBorder();
                                }, className: trimBorderActive, "data-tooltip-content": messages.editor.view_safety_distance, "data-tooltip-id": "editor-canvas-tooltip", children: _jsx("i", { className: "fad fa-border-outer" }) }), _jsx("a", { href: "#", onClick: () => {
                                    showGridF(gridActive);
                                }, className: grid, "data-tooltip-content": messages.editor.view_structure, "data-tooltip-id": "editor-canvas-tooltip", children: _jsx("i", { className: "fad fa-paragraph" }) }), _jsx("a", { href: "#", onClick: () => {
                                    props.showTour();
                                }, "data-tooltip-content": messages.editor.start_tutorial, "data-tooltip-id": "editor-canvas-tooltip", children: _jsx("i", { className: "fad fa-question" }) })] }), _jsxs("div", { id: "zoom-tools", children: [_jsx("a", { href: "#", onClick: () => fitAuto(), "data-tooltip-content": messages.editor.adjust_by_window, "data-tooltip-id": "editor-canvas-tooltip", children: _jsx("i", { className: "fad fa-arrows-alt" }) }), _jsx("a", { href: "#", onClick: () => fitWidth(), "data-tooltip-content": messages.editor.adjust_by_width, "data-tooltip-id": "editor-canvas-tooltip", children: _jsx("i", { className: "fad fa-arrows-alt-h" }) }), _jsx("a", { href: "#", onClick: () => fitHeight(), "data-tooltip-content": messages.editor.adjust_by_height, "data-tooltip-id": "editor-canvas-tooltip", children: _jsx("i", { className: "fad fa-arrows-alt-v" }) })] }), _jsxs("div", { id: "zoomer", children: [_jsx("div", { className: "intention", onClick: () => {
                                    if (pageZoom > 0.1) {
                                        newPageZoom = parseFloat((pageZoom - 0.1).toFixed(2));
                                        setPageZoom(newPageZoom);
                                    }
                                }, children: "-" }), _jsx(Slider, { ref: zoomerRef, step: 0.01, min: 0.01, max: 2, marks: {
                                    0.01: '1%',
                                    0.5: '50%',
                                    1: '100%',
                                    1.5: '150%',
                                    2: '200%',
                                }, defaultValue: pageZoom, value: pageZoom, onChange: (v) => setPageZoom(v) }), _jsx("div", { className: "intention", onClick: () => setPageZoom((pz) => (pz < 2 ? parseFloat((pz + 0.1).toFixed(2)) : pz)), children: "+" })] })] })] }, "scarlet_editor"));
};
// Redux wiring
const mapDispatchToProps = (dispatch) => {
    return {
        updateVar: (data) => {
            dispatch(updateVar(data));
        },
    };
};
const mapStateToProps = (state) => ({
    appIntl: state.intl,
    zHeight: state.layout.zHeight,
    zWidth: state.layout.zWidth,
    scrollView: state.layout.scrollView,
    viewActive: state.layout.viewActive,
    activateZoom: state.layout.activateZoom,
    zoomFactor: state.layout.zoomFactor,
    updateNotification: state.list.updates.updateNotification,
    ccToolbar: state.layout.ccToolbar,
});
export default withRouter(legacyInjectIntl(connect(mapStateToProps, mapDispatchToProps)(EditorCanvasFTs)));
